"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montagna-sulla-strada-del-vino": {
    "ab6d319e": [{
      "hkey": "79aa38db",
      "slug": "casignano",
      "name": "Casignano",
      "primary": true,
      "skipSearch": false
    }],
    "cfd7658c": [{
      "hkey": "98f4da0d",
      "slug": "fontanefredde",
      "name": "Fontanefredde",
      "primary": true,
      "skipSearch": false
    }],
    "56ef01c1": [{
      "hkey": "c9d45203",
      "slug": "gleno",
      "name": "Gleno",
      "primary": true,
      "skipSearch": false
    }],
    "f748faff": [{
      "hkey": "f8e67e18",
      "slug": "pinzano",
      "name": "Pinzano",
      "primary": true,
      "skipSearch": false
    }],
    "5777d87a": [{
      "hkey": "3bbdbd62",
      "slug": "kalditsch",
      "name": "Kalditsch",
      "primary": true,
      "skipSearch": false
    }],
    "bdbc2105": [{
      "hkey": "c0acf9c0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;